module.exports = __webpack_public_path__ + "img/btn_finished.1ce96f74.png";